const CUSTOM_SIGNATURE_URL = 'https://tophamtechbe.com/api/treas/comm/custom-signature';

export class CustomSignatureRequestError extends Error {
  constructor(message, status, code) {
    super(message);
    this.name = 'CustomSignatureRequestError';
    this.status = status;
    this.code = code || '';
  }
}

const getErrorMessage = (status) => {
  if (status === 401) return 'Your session has expired. Please sign in again.';
  if (status === 403) return 'Your account is not allowed to manage an email signature.';
  return 'Your email signature could not be saved right now.';
};

const requestCustomSignature = async (authToken, options = {}) => {
  if (!authToken) {
    throw new CustomSignatureRequestError(
      'Your session is missing an authentication token. Please sign in again.',
      401,
      'UNAUTHORIZED'
    );
  }

  const response = await fetch(CUSTOM_SIGNATURE_URL, {
    ...options,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${authToken}`,
      ...(options.body ? { 'Content-Type': 'application/json' } : {})
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new CustomSignatureRequestError(
      payload.message || getErrorMessage(response.status),
      response.status,
      payload.code
    );
  }

  const data = await response.json();
  return {
    configured: Boolean(data?.configured),
    profile: data?.profile || null
  };
};

export const getCustomSignature = (authToken) => requestCustomSignature(authToken, { method: 'GET' });

export const saveCustomSignature = (authToken, profile) => requestCustomSignature(authToken, {
  method: 'PUT',
  body: JSON.stringify(profile)
});
